var _path, _path2, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 45,
    viewBox: "0 0 168 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.26 15.86L61.47 23.72H67.02L64.32 15.86H64.26ZM53.79 32L61.92 10.58H66.75L74.76 32H69.87L68.25 27.23H60.24L58.56 32H53.79ZM86.3871 28.34C88.8171 28.34 90.0171 26.27 90.0171 24.05C90.0171 21.53 89.1471 19.28 86.3871 19.28C83.9871 19.28 82.9371 21.38 82.9371 23.69C82.9371 25.91 83.7471 28.34 86.3871 28.34ZM94.0671 16.49V31.01C94.0671 33.56 93.1371 37.88 86.0271 37.88C82.9671 37.88 79.4271 36.41 79.1871 32.9H83.4171C83.8071 34.49 85.0671 35.03 86.5971 35.03C88.9671 35.03 90.0471 33.44 90.0171 31.19V29.15H89.9571C89.0271 30.8 87.1971 31.55 85.3071 31.55C80.6271 31.55 78.6771 28.01 78.6771 23.75C78.6771 19.73 81.0171 16.07 85.3371 16.07C87.3771 16.07 88.9071 16.76 89.9571 18.56H90.0171V16.49H94.0671ZM104.877 10.58V14.09H100.617V10.58H104.877ZM100.617 32V16.49H104.877V32H100.617ZM111.351 32V10.58H115.611V32H111.351ZM125.476 22.58H132.406C132.016 20.42 131.086 19.28 129.016 19.28C126.256 19.28 125.566 21.38 125.476 22.58ZM136.666 25.28H125.476C125.596 28.01 126.886 29.21 129.286 29.21C130.996 29.21 132.376 28.16 132.646 27.2H136.396C135.196 30.89 132.646 32.42 129.136 32.42C124.246 32.42 121.216 29.06 121.216 24.26C121.216 19.61 124.426 16.07 129.136 16.07C134.416 16.07 136.996 20.51 136.666 25.28ZM142.312 32V10.58H146.572V32H142.312ZM167.057 16.49L160.577 33.95C159.647 36.44 158.147 37.46 155.237 37.46C154.367 37.46 153.497 37.4 152.627 37.31V33.8C153.437 33.89 154.277 33.98 155.117 33.95C156.227 33.83 156.767 32.96 156.767 32C156.767 31.67 156.707 31.34 156.587 31.04L151.127 16.49H155.687L159.197 27.11H159.257L162.647 16.49H167.057Z",
    fill: "#E8E4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5117 21L34 41L16 33.1646L22.5117 21Z",
    fill: "url(#paint0_linear_279_173)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.4998,
    y: 6.35559,
    width: 13.4252,
    height: 41.7121,
    rx: 6.71259,
    transform: "rotate(-26.5 14.4998 6.35559)",
    fill: "url(#paint1_linear_279_173)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6569,
    y: 0.0126343,
    width: 12.9582,
    height: 43.265,
    rx: 6.47912,
    transform: "rotate(28.5 20.6569 0.0126343)",
    fill: "url(#paint2_linear_279_173)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_279_173",
    x1: 24.7021,
    y1: 21.2534,
    x2: 20.9483,
    y2: 33.1327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C795EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#CC89E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D187E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_279_173",
    x1: 21.2453,
    y1: 13.095,
    x2: 6.2843,
    y2: 37.5073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F58B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638352,
    stopColor: "#FDC88E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E583CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_279_173",
    x1: 27.136,
    y1: 0.0126338,
    x2: 12.7629,
    y2: 16.2839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDFB96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#B5E0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4ABF2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo_full.e7cc1a2f6424ada25a79929246c1bbdb.svg";
export { ForwardRef as ReactComponent };